import React, { useEffect, useRef, useState } from 'react';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

// Generic click-outside-to-close menu. `trigger` receives {open, toggle}.
export default function Dropdown({ trigger, children, align = 'right', className = '' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      {trigger({ open, toggle: () => setOpen((o) => !o), close: () => setOpen(false) })}
      {open && (
        <div
          className={cx(
            'absolute mt-2 min-w-[12rem] bg-white rounded-xl shadow-lg border border-neutral-100 py-1 z-50 ring-1 ring-black/5',
            align === 'right' ? 'right-0' : 'left-0',
            className
          )}
        >
          {typeof children === 'function' ? children({ close: () => setOpen(false) }) : children}
        </div>
      )}
    </div>
  );
}

export function DropdownItem({ icon: Icon, children, className = '', ...rest }) {
  return (
    <button
      className={cx(
        'w-full flex items-center gap-2 px-4 py-2 text-sm text-neutral-600 hover:bg-neutral-50 text-left',
        className
      )}
      {...rest}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {children}
    </button>
  );
}
